export const QUIZ_VIEW = '/quiz'
export const JOURNEY_VIEW = '/journey'
export const REPORT_CARD_VIEW = '/report-card'
export const VIDEOS_VIEW = '/videos'
export const FEEDBACK_VIEW = '/feedback'
export const APPS_VIEW = '/apps'
export const HOME_VIEW = '/home'
export const PROFILE_VIEW = '/profile'
export const LEADERBOARD_VIEW = '/leaderboard'
export const FAQS_VIEW = '/faq'
export const LOGIN_VIEW = '/login'
export const LEGAL_VIEW = '/legal'
export const ONBOARDING_VIEW = '/'
export const EDIT_PROFILE_VIEW = '/edit-profile'
export const OTP_VIEW = '/otp'
export const REWARDS_VIEW = '/rewards'
export const REWARDS_HISTORY_VIEW = '/rewards-history'
export const REWARDS_COMPLETION_VIEW = '/rewards-complete'
export const CHILD_REPORT_VIEW = '/child-report-card'
export const CHILD_AGE_VIEW = '/child-age-view'
export const ONBOARD_REWARDS = '/onboard_rewards'
export const FAMILY_PROGRESS_VIEW = '/family_progress'
export const MONTHLY_WINNER_VIEW = '/monthly_winner'
export const WORKSHEET_VIEW = '/worksheet'
export const POINTS_AWARD_VIEW = '/points-award'
export const CERTIFICATE_VIEW = '/certificate'
export const WORKSHEETQUIZ_VIEW = '/worksheetquiz'
export const KID_ASSESSSMENT_VIEW = '/kid-assessment'
export const PARENT_SCREENER_VIEW = '/parent-screener'
export const HOW_TO_WIN_VIEW = '/how-to-win'
export const SCRATCH_POINTS = '/scratch-points'
